import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Table } from 'reactstrap';
import { FORMAT } from 'utils/dateOfBirthValidation';
import { useNavigate } from "react-router-dom";
import * as moment from 'moment';
import { stateConvert } from "utils/stateAbbreviation";
import { TableContainer } from "styles/components/ReactTable";
import EditIcon from 'assets/svg/EditIcon'
import DeleteIcon from 'assets/svg/DeleteIcon'
import AlertModal from "components/AlertModal";
import ConfirmationModal from "components/ConfirmationModal";
import { deleteOrder } from "redux/actions/requestPickupOrder";
import MixPalletDetailsModal from "components/MixPalletDetailsModal";
import { getLoggedInUserCountry } from "helpers";

const ReactTable = (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const loggedInUserInfo = JSON.parse(localStorage.getItem('loggedInUserData'))
  const token = loggedInUserInfo?.token
  const userCountry = getLoggedInUserCountry?.() || "USA";

  const [mixModalOpen, setMixModalOpen] = useState(false);
  const [selectedMixOrder, setSelectedMixOrder] = useState(null);

  const handleViewMixPallet = (data) => {
    setSelectedMixOrder(data);
    setMixModalOpen(true);
  };

  const [deleteOrderRefNumber, setDeleteOrderRefNumber] = useState()
  const [modal, setModal] = useState(false);
  const [modalContent, setModalContent] = useState("");
  const [modalTitle, setModalTitle] = useState("Alert");
  const [modalLink, setModalLink] = useState("/");
  const [modalResult, setModalResult] = useState("");
  const toggleModal = () => setModal(!modal);

  const [confirmationModal, setConfirmationModal] = useState(false);
  const [confirmationModalContent, setConfirmationModalContent] = useState("");
  const [confirmationModalLink, setConfirmationModalLink] = useState("/");
  const [confirmationAlertType, setConfirmationAlertType] = useState('')
  const toggleConfirmationModal = () => setConfirmationModal(!confirmationModal);

  const orderType = (items) => {
    let totalQuantity = items?.quantityDetails?.totalQuantity

    if (items?.requestType === 'PickUp') return totalQuantity + ', PickUp'

    let material = items?.palletDetails?.material
    let condition
    if (items?.palletDetails?.condition?.length !== 1) {
      condition = items?.palletDetails?.condition?.join(", ")
    } else {
      if (items?.palletDetails?.condition.length !== 0)
        condition = items?.palletDetails?.condition
    }

    let palletType;
    let moisture = "";
    let size = "";
    let grade = "";
    let LWH
    if (items?.palletDetails?.material !== "WOOD") {
      const length = items?.palletDetails?.length
      const width = items?.palletDetails?.width
      const height = items?.palletDetails?.height
      LWH = length + "x" + width + "x" + height
      // + ", " + material 
      if (condition) {
        condition = condition?.toString()
        condition = condition?.toLowerCase();
        condition = condition?.replace(/\b\w/g, c => c.toUpperCase())

        return totalQuantity + ", " + LWH + "-" + condition
      } else {
        return totalQuantity + ", " + LWH
      }

    } else {
      palletType = items?.palletDetails?.palletType

      if (items?.palletDetails?.size)
        size = ", " + items?.palletDetails?.size

      if (items?.palletDetails?.grade)
        grade = ", " + items?.palletDetails?.grade

      palletType = palletType?.toLowerCase();
      palletType = palletType?.replace(/\b\w/g, c => c.toUpperCase())
      condition = condition?.toString()
      condition = condition?.toLowerCase();
      condition = condition?.replace(/\b\w/g, c => c.toUpperCase())

      if (items?.palletDetails?.newConditionType) {
        let newConditionType
        if (items?.palletDetails?.newConditionType === 'HARDWOOD') newConditionType = '(HW)'
        else if (items?.palletDetails?.newConditionType === 'SOFTWOOD') newConditionType = '(SW)'
        if (newConditionType) condition = `${condition} ${newConditionType}`
      }
      return totalQuantity + "" + size + "" + grade + ", " + palletType + "-" + condition
    }
  }

  const editRequestOrderFunction = items => {
    localStorage.setItem('ordRefNoForFetchReqOrd', items?.orderRefNumber)
    if (items?.requestType === 'PickUp') navigate("/request-pickup-orders")
    else navigate("/request-orders")
  }

  const deleteRequestOrderConfirmation = (items) => {
    setDeleteOrderRefNumber(items?.orderRefNumber)
    setConfirmationModalContent(items?.requestType === 'PickUp' ? 'Are you sure you want to delete the pickup order request?' : 'Are you sure you want to delete the order request?');
    setConfirmationAlertType(items?.requestType === 'PickUp' ? 'deletePickupRequestOrder' : 'deleteRequestOrder')
    setConfirmationModalLink("");
    toggleConfirmationModal();
  }

  const deleteRequestOrderFunction = async (confirmationAlertType) => {
    let data = {
      orderRefNumber: deleteOrderRefNumber,
      emailId: [loggedInUserInfo?.email],
      locationName: loggedInUserInfo?.locationName
    }
    let response = await dispatch(deleteOrder(data, token));
    if (response?.data?.success) {
      setDeleteOrderRefNumber()
      setModalTitle("")
      setModalContent(confirmationAlertType === 'deletePickupRequestOrder' ? 'Pickup order request deleted successfully!' : 'Order request deleted successfully!');
      setModalLink("");
      toggleModal();
      setModalResult('successDelete')
    } else {
      setModalContent(response?.data?.error?.message || response.message || 'Someting went wrong, please try again in some time.');
      setModalLink("");
      toggleModal();
    }
  }

  return (
    <>
      <TableContainer>
        <Table responsive>
          <thead>
            <tr>
              {props?.headerArr.map((items, index) => (
                <th key={index}>{items}</th>
              ))}
              <th></th>
            </tr>
          </thead>
          <tbody>
            {props?.response?.orderLists.map((items, index) => (
              <tr key={index}>
                <td>{items?.orderRefNumber.trim()}</td>
                <td>{items?.poNumber}</td>
                <td>{items?.shippingAddress?.locationName} - {items?.shippingAddress?.street}</td>
                <td>{items?.shippingAddress?.city}, {stateConvert(items?.shippingAddress?.state) ? stateConvert(items?.shippingAddress?.state) : items?.shippingAddress?.state}</td>
                <td>{items?.requestedDate}</td>
                <td>
                  {(items?.mixPalletDetails || items?.multiplePalletCombination) ? (
                    <button
                      type="button"
                      className="view-mix-pallet-btn"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleViewMixPallet(items);
                      }}
                    >
                      View Mix Pallet
                    </button>
                  ) : (
                    orderType(items)
                  )}
                </td>
                <td>{items?.requestType === 'PickUp' ? 'Pickup' : 'Delivery'}</td>
                <td style={{ display: 'flex', gap: '6px' }}>
                  {loggedInUserInfo?.locationType !== 'PARENT_LOCATION' && <span style={{ cursor: 'pointer' }} onClick={() => editRequestOrderFunction(items)}><EditIcon /></span>}
                  <span style={{ cursor: 'pointer' }} onClick={() => deleteRequestOrderConfirmation(items)}><DeleteIcon /></span>
                </td>
                {items.postRecurrence ? <td><span style={{ background: '#FAE4AD', borderRadius: '28px', padding: '5px 7px 5px 10px', textWrap: 'nowrap', color: '#DB7516' }}>Recurring Order</span></td> : <td></td>}
              </tr>
            ))}

          </tbody>
        </Table>
        {props?.response?.orderLists?.length === 0 &&
          <div style={{ textAlign: 'center', padding: '12px' }}>No records found</div>}
      </TableContainer>

      <ConfirmationModal
        isOpen={confirmationModal}
        toggle={toggleConfirmationModal}
        content={confirmationModalContent}
        link={confirmationModalLink}
        className="alert-msg-container"
        InnerClassName="alert-msg"
        callBackAlert={() => {
          if (confirmationAlertType === 'deleteRequestOrder' || confirmationAlertType === 'deletePickupRequestOrder') {
            deleteRequestOrderFunction(confirmationAlertType)
            toggleConfirmationModal()
          } else {
            toggleConfirmationModal()
          }
        }}
      />

      <AlertModal
        isOpen={modal}
        toggle={toggleModal}
        title={modalTitle}
        content={modalContent}
        link={modalLink}
        className="alert-msg-container"
        InnerClassName="alert-msg"
        callBackAlert={() => {
          if (modalResult === 'successDelete') {
            setModalResult('')
            toggleModal()
            props.deleteCallback()
          } else toggleModal()
        }}
      />

      <MixPalletDetailsModal
        isOpen={mixModalOpen}
        toggle={() => setMixModalOpen(!mixModalOpen)}
        orderData={selectedMixOrder}
        loggedUserCountry={userCountry}
      />
    </>
  );
};

export default ReactTable;
